import { Component, OnInit } from '@angular/core';
import { Member } from 'src/app/model/member';
import { Team } from 'src/app/model/team';
import { Role } from 'src/app/model/role';
import { MemberService } from 'src/app/services/member.service';
import { TeamService } from 'src/app/services/team.service';
import { TeamSeasonService } from 'src/app/services/team-season.service';
import { RoleService } from 'src/app/services/role.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'member-detail-view',
  templateUrl: 'member-detail-view.html',
  styles: [
    ".member-detail-photo { max-height: 7.5rem; display: inline-block; }",
    ".member-detail-table { display: inline-block; vertical-align: top; }",
    "p { margin: 0.3rem; }",
    "th p { text-align: left; font-weight: normal; }",
    "td p { font-weight: bold; }"
  ]
})

export class MemberDetailViewComponent implements OnInit {
  member: Member;
  teams: Team[];
  roles: Role[];

  ngOnInit(): void {
    this.getMember();
  }

  constructor(
    private memberService: MemberService,
    private teamSeasonService: TeamSeasonService,
    private teamService: TeamService,
    private roleService: RoleService,
    private route: ActivatedRoute
  ) { }

  getMember(): void {
    // get member id from route
    const memberId = this.route.snapshot.paramMap.get("id");
    // get member
    this.memberService.getMembers().subscribe(members => {
      this.member = members.find(member => member.memberId === memberId);
      // get teams
      this.teamSeasonService.getTeamSeasons().subscribe(teamSeasons => {
        // get team ids from members team seasons
        let teamIds: string[] = teamSeasons.filter(teamSeason => teamSeason.players.map(player => player.memberId).includes(this.member.memberId))
          .map(teamSeason => teamSeason.teamId);
        // get teams from ids
        this.teamService.getTeams().subscribe(teams => {
          this.teams = teams.filter(team => teamIds.includes(team.teamId));
        });
      });
      // get roles
      this.roleService.getRoles().subscribe(roles => {
        this.roles = roles.filter(role => this.member.roleIds.includes(role.roleId));
      })
    });
  }

  private getRolesHeaderString(): string {
    return this.roles.length > 1 ? "Funktionen" : "Funktion";
  }

  private getTeamsHeaderString(): string {
    return this.teams.length > 1 ? "Teams" : "Team";
  }

  isPlayer(): boolean {
    return this.roles.map(role => role.roleId).includes("8F457492-4DB6-4A08-84AE-DF49FE593CFC");
  }

  private getAgeBand(): string {
    let year = new Date(this.member.dayOfBirth).getFullYear();
    if (year >= this.getYearFromAge(11)) {
      return "U11";
    } else if (year >= this.getYearFromAge(13)) {
      return "U13";
    } else if (year >= this.getYearFromAge(15)) {
      return "U15";
    } else if (year >= this.getYearFromAge(18)) {
      return "U18";
    } else if (year >= this.getYearFromAge(21)) {
      return "U21";
    } else if (year < this.getYearFromAge(80)) {
      return "S80";
    } else if (year < this.getYearFromAge(75)) {
      return "S75";
    } else if (year < this.getYearFromAge(70)) {
      return "S70";
    } else if (year < this.getYearFromAge(60)) {
      return "S60";
    } else if (year < this.getYearFromAge(50)) {
      return "S50";
    } else if (year < this.getYearFromAge(40)) {
      return "S40";
    }
    return "Allgemeine Klasse";
  }

  private getYearFromAge(age: number): number {
    let date = new Date();
    date.setMonth(date.getMonth() + 4);
    date.setFullYear(date.getFullYear() - age);
    return date.getFullYear();
  }
}
